"use strict";

exports.__esModule = !0, exports.default = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base")),
  _react = _interopRequireDefault(require("react")),
  _constants = require("../constants");
function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}
var NoData = function (a) {
    var b = a.props,
      c = a.state,
      d = a.methods;
    return b.noDataRenderer ? b.noDataRenderer({
      props: b,
      state: c,
      methods: d
    }) : /*#__PURE__*/_react.default.createElement(NoDataComponent, {
      className: _constants.LIB_NAME + "-no-data",
      color: b.color
    }, b.noDataLabel);
  },
  NoDataComponent = /*#__PURE__*/(0, _base.default)("div", "production" === process.env.NODE_ENV ? {
    target: "e1l5ho1t0"
  } : {
    target: "e1l5ho1t0",
    label: "NoDataComponent"
  })("padding:10px;text-align:center;color:", function (a) {
    var b = a.color;
    return b;
  }, ";" + ("production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL05vRGF0YS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFha0MiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvTm9EYXRhLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IExJQl9OQU1FIH0gZnJvbSAnLi4vY29uc3RhbnRzJztcblxuY29uc3QgTm9EYXRhID0gKHsgcHJvcHMsIHN0YXRlLCBtZXRob2RzIH0pID0+XG4gIHByb3BzLm5vRGF0YVJlbmRlcmVyID8gKFxuICAgIHByb3BzLm5vRGF0YVJlbmRlcmVyKHsgcHJvcHMsIHN0YXRlLCBtZXRob2RzIH0pXG4gICkgOiAoXG4gICAgPE5vRGF0YUNvbXBvbmVudCBjbGFzc05hbWU9e2Ake0xJQl9OQU1FfS1uby1kYXRhYH0gY29sb3I9e3Byb3BzLmNvbG9yfT5cbiAgICAgIHtwcm9wcy5ub0RhdGFMYWJlbH1cbiAgICA8L05vRGF0YUNvbXBvbmVudD5cbiAgKTtcblxuY29uc3QgTm9EYXRhQ29tcG9uZW50ID0gc3R5bGVkLmRpdmBcbiAgcGFkZGluZzogMTBweDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBjb2xvcjogJHsoeyBjb2xvciB9KSA9PiBjb2xvcn07XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBOb0RhdGE7XG4iXX0= */")),
  _default = NoData;
exports.default = _default;